module.exports = __webpack_public_path__ + "media/svg/linguagens-sign-cc52fe3f.svg";